import { publicUrlFor, route } from "../../../../globals/constants";
import { NavLink } from "react-router-dom";

function Video2({
    options,
    data 
}) {
    return (
        <div className="section-full  about-video p-t130 p-b80 overlay-wraper" data-stellar-background-ratio="0.5" style={{ backgroundImage: `url(${options?.image}` }}>
            <div className="overlay-main bg-secondry  opacity-09" />
            <div className="container text-center ">
                <a href={options?.video} className="mfp-video play-now">
                    <i className="icon fa fa-play" />
                    <span className="ripple" />
                </a>
                <div className="text-white help-section">
                    <h2 className="m-b30">{options?.title}</h2>
                    <h4 className="m-b30"><strong>{options?.description}</strong></h4>
                    <NavLink to={route.pages.contact.CONTACT1} className="site-button">Contact Us</NavLink>
                </div>
            </div>
        </div>
    )
}

export default Video2;
